import { IRootState } from '~store/modules/root';
import { SETTINGS_TAB_PATH } from '@qodly/shared';

export function setSettingsTabTouchedFlag(state: IRootState, touched: boolean) {
  const found = state.tabs.find(({ path }) => path === SETTINGS_TAB_PATH);

  if (found) {
    found.flags.touched = touched;
  }
}
